import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./Aboutus.module.css";
import about from "../../assets/about.png"
import { useSelector } from "react-redux";
import { motion } from "framer-motion";

export default function Aboutus() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  return (
    <div className={styles.aboutContainer}>
      <Container fluid>
        <Row>
          <Col md={6}>
            <div className={styles.aboutDes}>

                <h2 className="fw-bold">{currentLocal.general.about}</h2>
                <p>{currentLocal.general.aboutParag}</p>
                <p className="mt-4">{currentLocal.general.aboutDes}</p>
                   <ul className='p-0'>
                <li><p>{currentLocal.general.featureone}</p></li>
                <li><p>{currentLocal.general.featureTwo}</p></li>
                <li><p>{currentLocal.general.featureThree}</p></li>
            </ul> 
            </div>
          </Col>
          <Col md={6}>
            <div className={styles.aboutImg}>

              <img src={about} alt="about" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
